import React, {useState, useRef, useCallback, useEffect} from 'react'
import './menu.css';
import firebase from './../../config/fbConfig.js'
import { Link } from 'react-router-dom'
import MenuCategory from './menuCategory';
import Cart from './cart';
import {Helmet} from "react-helmet";

const db = firebase.firestore(); 

function Menu(props) {
    const [menu, setMenu] = useState([])
    let [cart, setCart] = useState({counter: 0, products: [], totalPrice: 0, times: []})
    const successToastTimeout = useRef()
    const [, updateState] = React.useState(); // To force render
    const forceUpdate = useCallback(() => updateState({}), []); // Force render
    const [chosenCategory, setChosenCategory] = useState(0)


    // Used when the user wants to cloes the success toast
    let closeSuccessToast = () => {
        document.getElementById('successAdded').hidden = true;
        document.getElementById('successAdded').classList.remove('animate');
        clearTimeout(successToastTimeout.current);
    }

    useEffect(() => {
        // To make sure that react can snapshot this component, and not get timeout, so skip the ajax request from firebase
        if (navigator.userAgent !== "ReactSnap") { 
            // If it is coming from Admin panel, just set the prop
            if (props.location===undefined) {
                setMenu(props.menu)
            } else {
                // If coming from other page = not menu, then load the document
                if (props.history.location.state === undefined) {
                    if (props.isAdmin==null) {
                        db.collection("menu").doc('categories').get().then(function(querySnapshot) {
                            if (window.location.href.includes('/en')) {
                                setMenu(querySnapshot.data().categoriesEN);
                            } else {
                                setMenu(querySnapshot.data().categoriesHE);
                            }
                        })   
                    }
                } else { // if coming from Menu category, don't load the document, just use the state and load cart properly

                    // If the page was loaded on specific category, then force load the whole menu, and push to the specific category if it was found in the menu
                    if (props.history.location.state.title != null ) {
                        const title = props.history.location.state.title;
                        const english = props.history.location.state.english;
                        // If it is from English page   
                        let menu;
                        if (english) {
                            db.collection("menu").doc('categories').get().then(function(querySnapshot) {
                                menu = querySnapshot.data().categoriesEN;
                            }).then(() => {
                                let index = menu.findIndex(i => i.title.toLowerCase() === title.toLowerCase());
                                if (index === -1) {
                                    setMenu(menu);
                                } else {    
                                    props.history.push({
                                        pathname: '/en' + getProperURL(title), state: { menu: menu, chosenCategory: menu[index].products, cart: cart}
                                    });                                                          
                                } 
                            })
                        } else {  // If it is from Hebrew page   
                            db.collection("menu").doc('categories').get().then(function(querySnapshot) {
                                menu = querySnapshot.data().categoriesHE;
                            }).then(() => {
                                let index = menu.findIndex(i => i.title.toLowerCase() === title.toLowerCase());
                                if (index === -1) {
                                    setMenu(menu);
                                } else {
                                              
                                    props.history.push({
                                        pathname: getProperURL(title), state: { menu: menu, chosenCategory: menu[index].products, cart: cart}
                                    });                            
                                } 
                            })
                        }
                        
                    } else { // If coming from category to menu, so save the menu details(to prevent another doc load) and set proper cart details accordding to the one from category
                        setCart(props.history.location.state.cart);
                        setMenu(props.history.location.state.menu);
                    }
                                
                }
            }
        }
    }, [])

    let titleBackground = () => {
		// Randomize color
		return { backgroundColor: "hsl(" + 360 * Math.random() + ',' +
		(25 + 70 * Math.random()) + '%,' + 
		(75 + 10 * Math.random()) + '%)'	}
	}

    let getProperURL = (title) => {
        let newTitle = title.replace(/\s/g, '-');
        return '/menu/' + newTitle;
    }


    // Used when clicked on a category from Admin Panel in show menu as admin
    let goDirectCategory = (index) => {
        setChosenCategory(props.menu[index].products);
        document.getElementById('gridContainer').hidden = true;
        setTimeout(() => {
            document.getElementById('containerCategory').style.display = 'block';
            setTimeout(() => {
                document.getElementById('chosenCategory').classList.add('active');
                document.getElementById('goBackMenu').classList.add('active');
            }, 100)
        }, 30)
      
    }

    if (menu===undefined) return null;

    if (window.location.href.includes('/en')) { 
    return (
        <div id="menu">
        <Helmet>
            <html lang="en" />
            <title>Menu | Itay's Restaurant</title>
            <meta 
            name="description" 
            content="Itay's Restaurant Menu. We make a 'rise' to the best dishes in the world, presenting a menu of all worlds: Israeli, Italian, American, Far East, and Mexican in one restaurant." />
        </Helmet>

        <div id="CreditNafis">
            * Pay attention this is <b>not a real restaurant</b>.<br/>
            Most pictures here are taken from <a href="https://storage.googleapis.com/emenu_webview/webview.html?SiteID=2038&p=1"> Nafis נאפיס</a> restaurant ©
        </div>

        {menu==null || menu.length===0 ? <img id="loadingGif" src="/assets/loadingGif.gif"/>

        :

        <div id="gridContainer">

            {props.isAdmin==null ? // In case it isn't an admin, so filtering only the Unhidden categories
            <div id="gridMenu">
                {menu.filter(value => !value.isHidden).map((value, index) =>
                    <Link to={{ pathname: '/en' + getProperURL(value.title), state: { menu: menu, chosenCategory: menu[index].products, cart: cart} }} key={index}>
                    <div className="gridBody">
                        <img className="categoryPic" src={value.CategoryURL} onLoad={(e) => e.target.classList.add('loaded')} alt="category pic"/>
                        <div className="categoryTitle" style={titleBackground()}>{value.title}</div>
                    </div>
                    </Link>
                )}
            </div>
            : // In case it is an admin, so showing the whole menu
            <div id="gridMenu">
                {menu.map((value, index) =>       
                    <div className="gridBody" key={index} data-id={index} onClick={() => goDirectCategory(index)}>
                        <img className="categoryPic" src={value.CategoryURL} onLoad={(e) => e.target.classList.add('loaded')} alt="category pic"/>
                        <div className="categoryTitle" style={titleBackground()}>{value.title}</div>
                    </div>
                )}
            </div>
            }
        </div>

        }

        {(props.isAdmin!=null && chosenCategory!==0) && // This will be shown only in Admin Panel because It's SPA and not routes
        <div id="containerCategory" style={{display: 'none'}}>
          <MenuCategory isAdmin={props.isAdmin} chosenCategory={chosenCategory}/>
        </div>
        }

        {props.isAdmin==null && <Cart cart={cart} setCart={setCart} closeSuccessToast={closeSuccessToast} forceUpdate={forceUpdate}/>}
        
    </div>       
    )
}


// Else render it in english
    return (
        <div id="menu" className="hebrew">
            <Helmet>
                <title>תפריט | המסעדה של איתי</title>
                <meta 
                name="description" 
                content='המסעדה של איתי עושה "עלייה" למנות הטובות בעולם, ובכך מציגה תפריט מכל העולמות: הישראלי, האיטלקי, האמריקאי, המזרח הרחוק, והמקסיקני.'/>
            </Helmet>

            <div id="CreditNafis">
                * שים לב: <b>זהו לא אתר של מסעדה אמיתית</b>.<br/>
                רוב התמונות שנמצאות כאן לקוחות ממסעדת <a href="https://storage.googleapis.com/emenu_webview/webview.html?SiteID=2038&p=1">נאפיס</a> ©
            </div>

            {menu==null || menu.length===0 ? <img id="loadingGif" src="/assets/loadingGif.gif"/>

            :

            <div id="gridContainer">

                {props.isAdmin==null ? // In case it isn't an admin, so filtering only the Unhidden categories
                <div id="gridMenu">
                    {menu.filter(value => !value.isHidden).map((value, index) =>
                        <Link to={{ pathname: getProperURL(value.title), state: { menu: menu, chosenCategory: menu[index].products, cart: cart} }} key={index}>
                        <div className="gridBody">
                            <img className="categoryPic" src={value.CategoryURL} onLoad={(e) => e.target.classList.add('loaded')} alt="category pic"/>
                            <div className="categoryTitle" style={titleBackground()}>{value.title}</div>
                        </div>
                        </Link>
                    )}
                </div>
                : // In case it is an admin, so showing the whole menu
                <div id="gridMenu">
                    {menu.map((value, index) =>       
                        <div className="gridBody" key={index} data-id={index} onClick={() => goDirectCategory(index)}>
                            <img className="categoryPic" src={value.CategoryURL} onLoad={(e) => e.target.classList.add('loaded')} alt="category pic"/>
                            <div className="categoryTitle" style={titleBackground()}>{value.title}</div>
                        </div>
                    )}
                </div>
                }
            </div>

            }

            {(props.isAdmin!=null && chosenCategory!==0) && // This will be shown only in Admin Panel because It's SPA and not routes
            <div id="containerCategory" style={{display: 'none'}}>
            <MenuCategory isAdmin={props.isAdmin} chosenCategory={chosenCategory}/>
            </div>
            }

            {props.isAdmin==null && <Cart cart={cart} setCart={setCart} closeSuccessToast={closeSuccessToast} forceUpdate={forceUpdate}/>}
            
        </div>
    )
}

export default Menu